import VoteButton from "./VoteButton";

const MobileVoteBar = () => {
  return (
    <div className="mobilebar">
      <VoteButton location="barre mobile" />
    </div>
  );
};

export default MobileVoteBar;
